// TODO: switch value type to GDSSpacing when theme shape is merged
export const paddingX = (value: any) => ({
  paddingInlineStart: value,
  paddingInlineEnd: value,
});

export const paddingY = (value: any) => ({
  paddingTop: value,
  paddingBottom: value,
});
